export default __webpack_public_path__ + "static/media/icon-forget-whatsapp.0de52b40.webp";